import Immutable from "seamless-immutable";

const initialState = Immutable({});

const VehiclesReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default VehiclesReducer;
